<!--/*
 * @name: 设备监控详情
 * @description: 设备监控详情
 * @author: zefeng(zefeng.chen@shengyc.com)
 * @Date: 2019-08-09 10:04:14
 * @LastEditTime: 2019-08-09 10:04:14
 */-->
<template>
    <div class="main-container">
        <van-pull-refresh v-model="showLoading" success-text="刷新成功" @refresh="onRefresh">
            <Loading v-if="showLoading" />
            <div id="tabMain" v-else-if="data.length > 0">
                <div class="container" v-if="data.length == 1">
                    <monitoring-panel
                        :id="getUrlKey('equipment_id') || equipment_id"
                        @isHeader="$_isHeader"
                        :comDataList="data[0].infos"
                        mode="1"
                        :realTimeData="realTimeData"
                        @getData="$_getData"
                    />
                </div>
                <van-tabs v-else title-active-color="#335ECF" title-inactive-color="#333" @click="onClick">
                    <van-tab
                        v-for="(item, index) in data"
                        :title="strLimit(pathOr('监控页面', ['title'], item), 6)"
                        :key="'data' + index"
                        :swipe-threshold="4"
                    >
                        <div class="container">
                            <monitoring-panel
                                :id="getUrlKey('equipment_id') || equipment_id"
                                @isHeader="$_isHeader"
                                :comDataList="item.infos"
                                mode="1"
                                :realTimeData="realTimeData"
                                @getData="$_getData"
                            />
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="noDataContainer" v-else>
                <img src="../../assets/images/icon_no_data.png" alt class="noData" />
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
import MonitoringPanel from './MonitoringPanel.vue'
import { get_equipment_monitor_info, get_statistic } from '@/service/getData'
import { getUrlKey, pathOr, strLimit } from '@/config/Utils'
import moment from 'moment'
// import NoData from '@/components/common/noData.vue'
import Loading from '@/components/common/Loading/'

export default {
    name: 'MonitoringDetailsScreen',
    components: { MonitoringPanel, Loading },
    data() {
        return {
            strLimit: strLimit,
            getUrlKey: getUrlKey,
            pathOr: pathOr,
            equipment_id: this.$route.query.equipment_id || this.equipmentId,
            isHeader: this.$route.query.isHeader || false,
            data: [],

            realTimeData: {},
            showLoading: true,
            loading: false,
            tabIndex: 0,
            monitor_info_id: ''
        }
    },
    props: {
        equipmentId: {
            type: String,
            default: () => ''
        },
        orderActive: {
            type: String
        }
    },
    created() {
        this.equipment_id_byRn = getUrlKey('equipment_id') || this.$route.query.equipment_id
        this.tokenByRn = getUrlKey('token') || this.$route.query.token 
        this.$_getData()
        clearInterval(this.timer)
        this.getRealtimeData()
        this.timer = setInterval(() => {
            this.getRealtimeData()
        }, 5000)
    }, 
    activated() {
        clearInterval(this.timer)
        this.getRealtimeData()
        this.timer = setInterval(() => {
            this.getRealtimeData()
        }, 5000)
    },
    deactivated() {
        clearInterval(this.timer)
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    watch: {
        orderActive: {
            handler(val) {
                if (val !== 'monitoring') {
                    clearInterval(this.timer)
                }
            },
            immediate: true
        }
    },
    methods: {
        // 下拉刷新
        onRefresh() {
            this.loading = true
            this.showLoading = true
            this.$_getData()
        },
        onClick(index, title) {
            this.tabIndex = index
            this.monitor_info_id = this.data && this.data[index] && this.data[index].id
        },
        $_isHeader(val) {
            if (val) {
                this.isHeader = true
            } else {
                this.isHeader = false
            }
        },
        $_getData() { 
            get_equipment_monitor_info({
                token: this.tokenByRn ? this.tokenByRn : localStorage.getItem(location.host + 'token'),
                equipment_info_id: this.equipment_id_byRn ? this.equipment_id_byRn : this.equipment_id
            })
                .then(res => {
                    this.data = res
                    this.monitor_info_id = res && res[this.tabIndex] && res[this.tabIndex].id
                    setTimeout(() => {
                        this.showLoading = false
                        this.loading = false
                    }, 500)
                })
                .catch(err => {
                    this.showLoading = false
                    this.loading = false
                })
        },
        getRealtimeData() { 
            get_statistic({ 
                token: this.tokenByRn ? this.tokenByRn : localStorage.getItem(location.host + 'token'),
                equipment_id: this.equipment_id_byRn ? this.equipment_id_byRn : this.equipment_id,
                date: moment(new Date()).format('YYYY-MM-DD'),
                monitor_info_id: this.monitor_info_id
            })
                .then(json => {
                    if (json) {
                        this.realTimeData = json
                    } else {
                        clearInterval(this.timer)
                    }
                })
                .catch(err => {
                    clearInterval(this.timer)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
.main-container {
    display: flex;
    flex-direction: column;
    .nav-btn_left {
        display: block;
        @include wh(vw(44), vw(44));
        background: transparent url('../../assets/images/left_arrow_W.png') no-repeat center center;
        background-size: vw(10), vw(18);
    }
}
#tabMain {
    .van-tabs__line {
        background-color: #335ecf !important;
    }
    .container {
        background-color: #fff;
        flex: 1;
        display: flex;
        margin-top: vw(7);
        padding: vw(18) vw(16);
    }
    ::v-deep .van-tab__text {
        min-width: vw(90) !important;
        text-align: center;
    }
}

$c: #1048b0;
$no-break-border: #888;
$online: #00ffcb;
$run: #00ccff;
$breakdown: #ff6c00;
$runStatus: #46ea8d;
$stopStatus: #fff;
$breakStatus: #ff6c00;
$offStatus: #000;
%h-100 {
    height: 100%;
}
%relative {
    position: relative;
}
%absolute {
    position: absolute;
}
%w-100 {
    width: 100%;
}
%h-100 {
    height: 100%;
}
%pointer {
    cursor: pointer;
}
%block {
    display: block;
}
%wh-100 {
    @extend %w-100;
    @extend %h-100;
}
%inherit {
    text-decoration: inherit;
}
%text-ell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
%box {
    box-sizing: border-box;
}
%origin {
    transform-origin: left top;
}
%flex {
    display: flex;
    align-items: center;
}
.new-real-time-container {
    @extend %h-100;
    @extend %relative;
}
.new-real-time-content {
    @extend %h-100;
    overflow: auto;
    background-color: #fff;
    &::-webkit-scrollbar-thumb {
        background-color: #ddd;
    }
}
.scale-container {
    // min-width: 100%;
    // min-height: 100%;
    @extend %relative;
    @extend %origin;
}
.scale-adjust-container {
    @extend %absolute;
    top: 5px;
    right: 20px;
    background-color: #eee;
    padding: 5px;
    color: #666;
    font-size: 12px;
    border-radius: 4px;
    @extend %flex;
    justify-content: center;
    height: 26px;
    .el-input-number {
        width: 60px;
        @extend %h-100;
        @extend %relative;
        top: -2px;
    }
}
.percent {
    margin-left: 5px;
}
.component-data-container {
    @extend %absolute;
    @extend %pointer;
    @extend %origin;
}
.component-data-content {
    @extend %wh-100;
    @extend %inherit;
    img {
        @extend %block;
    }
}
.com-img-container {
    @extend %wh-100;
    @extend %relative;
    img {
        @extend %wh-100;
        @extend %block;
    }
    svg {
        @extend %wh-100;
        overflow: visible;
        @extend %absolute;
        min-width: 1px;
        min-height: 1px;
        filter: none;
    }
}
.com-text-container {
    @extend %wh-100;
    @extend %box;
    padding: 10px;
    @extend %inherit;
}
.com-text-content {
    padding: 10px;
    @extend %w-100;
    @extend %text-ell;
    @extend %inherit;
    > span {
        @extend %inherit;
        @extend %relative;
        top: -1px;
    }
}
.com-border-container {
    @extend %wh-100;
}
.dialog-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #2a2a2a;
    color: #fff;
}
.dialog-content {
    padding: 20px;
    background-color: #dfdfdf;
}
.add-select-container {
    margin-bottom: 20px;
    .el-input-number {
        @extend %w-100;
    }
}
.btn-group {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    button {
        border: none;
        @extend %pointer;
        border-radius: 4px;
        width: 30%;
        @extend %h-100;
        color: #fff;
        background-color: #666;
        &.save {
            background-color: #004499;
        }
        & + button {
            margin-left: 10%;
        }
    }
}
.var-container {
    margin-bottom: 20px;
    @extend %text-ell;
}
.com-chart-container {
    @extend %h-100;
    // background-color: #2a2a2a;
    // background-color: rgba(228,240,250,0.3);
    background-color: #f7fafd;
    border-radius: 8px;
    box-shadow: 0px 3px 12px 0px rgba(90, 111, 190, 0.8);
    padding: 10px 15px;
    @extend %box;
}
.chart-title-container {
    @extend %w-100;
    @extend %flex;
    @extend %relative;
    margin-bottom: 10px;
}
.chart-title {
    @extend %w-100;
    @extend %box;
    padding-right: 278px;
    font-weight: bold;
    color: #aaa;
    @extend %text-ell;
}
.com-capacity-container {
    @extend %h-100;
    &:not(.column) {
        .com-capacity-item + .com-capacity-item {
            margin-left: 15px;
        }
    }
}
.com-capacity-item {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    span {
        color: #aaa;
    }
}
.com-capacity-content {
    @extend %w-100;
    border-radius: 4px;
    @extend %flex;
    justify-content: center;
    margin-top: 5px;
    p {
        @extend %w-100;
        @extend %text-ell;
        text-align: center;
    }
}
.time-select-wrap {
    @extend %absolute;
    @extend %h-100;
    right: 0;
    top: 0;
}
.noDataContainer {
    background-color: #fff;
    // flex: 1;
    // display: flex;
    @include fja(center, flex-start);
    @include wh(100vw, 100vh);
    padding-top: vw(84);
    .noData {
        width: vw(255);
        height: vw(255);
    }
}
::v-deep .van-tabs__nav--line {
    overflow-x: auto;
}
</style>
<style lang="scss">
#tabMain {
    .van-tabs__line {
        background-color: #335ecf;
    }
    .container {
        background-color: #fff;
        flex: 1;
        display: flex;
        margin-top: vw(7);
        padding: vw(18) vw(16);
    }
}
</style>
